import "@fortawesome/fontawesome-free/scss/fontawesome"
import "@fortawesome/fontawesome-free/scss/solid"
import "@fortawesome/fontawesome-free/scss/regular"
import "@fortawesome/fontawesome-free/scss/brands"